import { ApolloQueryResult } from 'apollo-client';
import gql from 'graphql-tag';
import { getContentfulClient } from 'graphql/clients';
import { GeneralCTAInfoQuery } from 'graphql/__generated__/operations/GeneralCtaInfo';
import { GeneralCTAInfo } from 'rest/contentful/types';

const GeneralCtaInfoQuery = gql`
  query GetCtaInfo($name: String!) {
    ctaInfoCollection(where: { name_contains: $name }) {
      __typename
      items {
        name
        rawText
        location
        goal
        linkDestination
        detailsText
        successMessage
        errorMessage
        headline
      }
    }
  }
`;

export const getGeneralCtaInfo = async (
  name: string,
): Promise<GeneralCTAInfo | null> => {
  const ContentfulClient = getContentfulClient(false);

  const {
    data,
    errors,
  }: ApolloQueryResult<GeneralCTAInfoQuery> = await ContentfulClient.query({
    query: GeneralCtaInfoQuery,
    variables: { name },
    errorPolicy: 'none',
  });

  if (errors) {
    return null;
  }

  return data?.ctaInfoCollection?.items?.[0] ?? null;
};
